module.exports = __webpack_public_path__ + "img/logo.157ddbe8.png";